<template>
    <close-tariff
        :on-close="handleCloseTariff"
        :tariff="tariff && tariff.title"
        :btnIsDisabled="btnIsDisabled"
    />
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import CloseTariff from "./CloseTariff.vue";

    export default {
        name: 'close-tariff-container',
        components: {
            CloseTariff
        },
        props: {
            btnIsDisabled: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            ...mapActions('profileTariff', ['closeTariff', 'fetchProfileTariff']),
            ...mapActions('request', ['fetchAvailableProducts']),

            handleCloseTariff() {
                return this.closeTariff().then(() => {
                    this.fetchProfileTariff();
                    this.fetchAvailableProducts();
                    this.$router.push({path: '/tariff'})
                    this.$emit('closed');
                });
            },
        },
        computed: {
            ...mapGetters('profileTariff', ['tariff']),
        }
    }
</script>


// WEBPACK FOOTER //
// CloseTariffContainer.vue?4ea8920b